class CartDrawer extends HTMLElement {
  constructor() {
    super();

    this.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
    this.querySelector('#CartDrawer-Overlay').addEventListener('click', this.close.bind(this));
    this.setHeaderCartIconAccessibility();
  }

  setHeaderCartIconAccessibility() {
    const cartLink = document.querySelector('#cart-icon-bubble');
    if (!cartLink) return;

    cartLink.setAttribute('role', 'button');
    cartLink.setAttribute('aria-haspopup', 'dialog');
    cartLink.addEventListener('click', (event) => {
      event.preventDefault();
      this.open(cartLink);
    });
    cartLink.addEventListener('keydown', (event) => {
      if (event.code.toUpperCase() === 'SPACE') {
        event.preventDefault();
        this.open(cartLink);
      }
    });
  }

  open(triggeredBy) {
    if (triggeredBy) this.setActiveElement(triggeredBy);
    const cartDrawerNote = this.querySelector('[id^="Details-"] summary');
    if (cartDrawerNote && !cartDrawerNote.hasAttribute('role')) this.setSummaryAccessibility(cartDrawerNote);
    // here the animation doesn't seem to always get triggered. A timeout seem to help
    setTimeout(() => {
      this.classList.add('animate', 'active');
    });

    this.addEventListener(
      'transitionend',
      () => {
        const containerToTrapFocusOn = this.classList.contains('is-empty')
          ? this.querySelector('.drawer__inner-empty')
          : document.getElementById('CartDrawer');
        const focusElement = this.querySelector('.drawer__inner') || this.querySelector('.drawer__close');
        trapFocus(containerToTrapFocusOn, focusElement);
      },
      { once: true }
    );

    document.body.classList.add('overflow-hidden');
  }

  close() {
    this.classList.remove('active');
    removeTrapFocus(this.activeElement);
    document.body.classList.remove('overflow-hidden');
  }

  setSummaryAccessibility(cartDrawerNote) {
    cartDrawerNote.setAttribute('role', 'button');
    cartDrawerNote.setAttribute('aria-expanded', 'false');

    if (cartDrawerNote.nextElementSibling.getAttribute('id')) {
      cartDrawerNote.setAttribute('aria-controls', cartDrawerNote.nextElementSibling.id);
    }

    cartDrawerNote.addEventListener('click', (event) => {
      event.currentTarget.setAttribute('aria-expanded', !event.currentTarget.closest('details').hasAttribute('open'));
    });

    cartDrawerNote.parentElement.addEventListener('keyup', onKeyUpEscape);
  }

  renderContents(parsedState) {
    this.querySelector('.drawer__inner').classList.contains('is-empty') &&
      this.querySelector('.drawer__inner').classList.remove('is-empty');
    this.productId = parsedState.id;
    this.getSectionsToRender().forEach((section) => {
      const sectionElement = section.selector
        ? document.querySelector(section.selector)
        : document.getElementById(section.id);

      if (!sectionElement) return;
      sectionElement.innerHTML = this.getSectionInnerHTML(parsedState.sections[section.id], section.selector);
    });

    setTimeout(() => {
      this.querySelector('#CartDrawer-Overlay').addEventListener('click', this.close.bind(this));
      this.open();
    });
  }

  getSectionInnerHTML(html, selector = '.shopify-section') {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector).innerHTML;
  }

  getSectionsToRender() {
    return [
      {
        id: 'cart-drawer',
        selector: '#CartDrawer',
      },
      {
        id: 'cart-icon-bubble',
      },
    ];
  }

  getSectionDOM(html, selector = '.shopify-section') {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector);
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}

customElements.define('cart-drawer', CartDrawer);

class CartDrawerItems extends CartItems {
  getSectionsToRender() {
    return [
      {
        id: 'CartDrawer',
        section: 'cart-drawer',
        selector: '.drawer__inner',
      },
      {
        id: 'cart-icon-bubble',
        section: 'cart-icon-bubble',
        selector: '.shopify-section',
      },
    ];
  }
}

customElements.define('cart-drawer-items', CartDrawerItems);

/* ------------------------------------------------------------------
   Poklon pakovanje (per item gift wrapping)

   Puts a checkbox under every product line in the cart drawer. If that
   line holds more than one item, a small counter appears so the buyer
   can wrap only some of them. Each wrapped line gets its own hidden
   wrap line in the cart, tagged with the variant it belongs to, so the
   charge is correct without the buyer having to explain anything.

   Those wrap lines are hidden in the drawer because the cost is already
   shown next to the item. Checkout will list them separately.
   ------------------------------------------------------------------ */
(function () {
  const WRAP_VARIANT_ID = 41629930455098;
  const WRAP_PRICE = 350;
  const CURRENCY = 'RSD';
  const LABEL = 'Poklon pakovanje za ' + WRAP_PRICE + ' ' + CURRENCY;
  const OF_TEXT = 'od';
  const TAG_VISIBLE = 'Pakovanje za';
  const TAG_HIDDEN = '_dp_wrap';
  const ROOT = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  const SECTIONS = 'cart-drawer,cart-icon-bubble';

  let working = false;
  let decorating = false;

  function injectStyles() {
    if (document.getElementById('dp-giftwrap-styles')) return;
    const s = document.createElement('style');
    s.id = 'dp-giftwrap-styles';
    s.textContent =
      '.dp-wrap-row{display:none!important}' +
      '.dp-gw{margin:.8rem 0 0;font-size:1.2rem;line-height:1.35}' +
      '.dp-gw__row{display:flex;align-items:center;gap:.7rem;cursor:pointer;margin:0}' +
      '.dp-gw__row input{width:1.5rem;height:1.5rem;margin:0;flex:0 0 auto;cursor:pointer;accent-color:#1a315e}' +
      '.dp-gw__label{opacity:.85}' +
      '.dp-gw__qty{display:none;align-items:center;gap:.6rem;margin:.6rem 0 0 2.2rem}' +
      '.dp-gw.is-on .dp-gw__qty{display:flex}' +
      '.dp-gw__num{width:5rem;padding:.35rem .5rem;font-size:1.2rem;font-family:inherit;color:rgb(var(--color-foreground));background:transparent;border:1px solid rgba(var(--color-foreground),.3)}' +
      '.dp-gw__meta{opacity:.7}' +
      '.dp-gw.is-busy{opacity:.45;pointer-events:none}';
    document.head.appendChild(s);
  }

  function getDrawer() {
    return document.querySelector('cart-drawer');
  }

  async function getCart() {
    const r = await fetch(ROOT + 'cart.js', { headers: { Accept: 'application/json' } });
    return r.json();
  }

  async function post(path, payload) {
    const r = await fetch(ROOT + path, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(payload),
    });
    return r.json();
  }

  function isWrap(item) {
    return item && item.variant_id === WRAP_VARIANT_ID;
  }

  function wrapFor(cart, variantId) {
    return (
      cart.items.find(function (i) {
        return isWrap(i) && i.properties && String(i.properties[TAG_HIDDEN]) === String(variantId);
      }) || null
    );
  }

  function productLineFor(cart, variantId) {
    return (
      cart.items.find(function (i) {
        return !isWrap(i) && i.variant_id === variantId;
      }) || null
    );
  }

  function paint(state) {
    const drawer = getDrawer();
    if (drawer && state && state.sections) drawer.renderContents(state);
  }

  async function apply(variantId, productTitle, quantity) {
    if (working) return;
    working = true;
    try {
      const cart = await getCart();
      const product = productLineFor(cart, variantId);
      const max = product ? product.quantity : 0;
      const want = Math.max(0, Math.min(quantity, max));
      const line = wrapFor(cart, variantId);
      let state = null;

      if (line) {
        state = await post('cart/change.js', { id: line.key, quantity: want, sections: SECTIONS });
      } else if (want > 0) {
        const props = {};
        props[TAG_VISIBLE] = productTitle;
        props[TAG_HIDDEN] = String(variantId);
        state = await post('cart/add.js', {
          items: [{ id: WRAP_VARIANT_ID, quantity: want, properties: props }],
          sections: SECTIONS,
        });
      }
      if (state) paint(state);
    } catch (e) {
      console.warn('[giftwrap] apply failed', e);
    } finally {
      working = false;
    }
  }

  async function tidy(cart) {
    // Drop or clamp wrap lines whose product is gone or reduced.
    if (working) return false;
    const orphans = cart.items.filter(function (i) {
      if (!isWrap(i) || !i.properties) return false;
      const target = productLineFor(cart, Number(i.properties[TAG_HIDDEN]));
      return !target || i.quantity > target.quantity;
    });
    if (!orphans.length) return false;
    const first = orphans[0];
    const target = productLineFor(cart, Number(first.properties[TAG_HIDDEN]));
    working = true;
    try {
      const state = await post('cart/change.js', {
        id: first.key,
        quantity: target ? target.quantity : 0,
        sections: SECTIONS,
      });
      paint(state);
      return true;
    } catch (e) {
      console.warn('[giftwrap] tidy failed', e);
      return false;
    } finally {
      working = false;
    }
  }

  function buildControl(item, existing) {
    const on = !!existing;
    const box = document.createElement('div');
    box.className = 'dp-gw' + (on ? ' is-on' : '');

    const label = document.createElement('label');
    label.className = 'dp-gw__row';
    const check = document.createElement('input');
    check.type = 'checkbox';
    check.checked = on;
    const span = document.createElement('span');
    span.className = 'dp-gw__label';
    span.textContent = LABEL;
    label.appendChild(check);
    label.appendChild(span);
    box.appendChild(label);

    const qtyWrap = document.createElement('div');
    qtyWrap.className = 'dp-gw__qty';
    const num = document.createElement('input');
    num.type = 'number';
    num.className = 'dp-gw__num';
    num.min = '1';
    num.max = String(item.quantity);
    num.step = '1';
    num.value = String(on ? existing.quantity : item.quantity);
    const meta = document.createElement('span');
    meta.className = 'dp-gw__meta';

    function refreshMeta() {
      const n = Math.max(1, Math.min(parseInt(num.value, 10) || 1, item.quantity));
      meta.textContent = OF_TEXT + ' ' + item.quantity + '  ·  ' + n * WRAP_PRICE + ' ' + CURRENCY;
    }
    refreshMeta();

    qtyWrap.appendChild(num);
    qtyWrap.appendChild(meta);
    if (item.quantity > 1) box.appendChild(qtyWrap);

    check.addEventListener('change', function () {
      box.classList.toggle('is-on', check.checked);
      box.classList.add('is-busy');
      const n = check.checked ? Math.max(1, Math.min(parseInt(num.value, 10) || item.quantity, item.quantity)) : 0;
      apply(item.variant_id, item.product_title, n);
    });

    num.addEventListener('change', function () {
      let n = parseInt(num.value, 10);
      if (isNaN(n) || n < 1) n = 1;
      if (n > item.quantity) n = item.quantity;
      num.value = String(n);
      refreshMeta();
      if (check.checked) {
        box.classList.add('is-busy');
        apply(item.variant_id, item.product_title, n);
      }
    });

    return box;
  }

  async function decorate() {
    if (decorating || working) return;
    const drawer = getDrawer();
    if (!drawer) return;
    const inner = drawer.querySelector('.drawer__inner');
    if (!inner || inner.classList.contains('is-empty')) return;
    const rows = Array.prototype.slice.call(drawer.querySelectorAll('.cart-item'));
    if (!rows.length) return;

    decorating = true;
    try {
      injectStyles();
      const cart = await getCart();
      if (await tidy(cart)) return;

      rows.forEach(function (row, idx) {
        const item = cart.items[idx];
        if (!item) return;
        if (isWrap(item)) {
          row.classList.add('dp-wrap-row');
          return;
        }
        const details = row.querySelector('.cart-item__details');
        if (!details) return;
        const stale = details.querySelectorAll('.dp-gw');
        for (let i = 0; i < stale.length; i++) stale[i].remove();
        details.appendChild(buildControl(item, wrapFor(cart, item.variant_id)));
      });
    } catch (e) {
      console.warn('[giftwrap] decorate failed', e);
    } finally {
      decorating = false;
    }
  }

  let pending = null;
  function schedule() {
    clearTimeout(pending);
    pending = setTimeout(decorate, 90);
  }

  function watch() {
    const drawer = getDrawer();
    if (!drawer) return;
    new MutationObserver(schedule).observe(drawer, { childList: true, subtree: true });
    schedule();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', watch);
  } else {
    watch();
  }
})();
